function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { AppErrorProvider, AppProvider as BaseAppProvider, RoutingProvider, ErrorNamespaceProvider, BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
import { FrontendApiClientBaseProvider, FrontendApiClientProvider, FrontendApiConfigProvider, HeadersProvider } from '@edreamsodigeo/frontend-api-client';
import { useFeatureVariationsQuery } from './UseFeatureVariationsQuery';
export const AppShellProvider = ({
  site,
  brand,
  locale,
  currencyLocale,
  dateLocale,
  baseProps,
  children,
  disableTracking
}) => {
  const featuresResult = useFeatureVariationsQuery(baseProps);
  return /*#__PURE__*/React.createElement(BaseAppProvider, _extends({
    site: site,
    brand: brand,
    locale: locale,
    currencyLocale: currencyLocale,
    dateLocale: dateLocale,
    featuresResult: featuresResult,
    disableTracking: disableTracking
  }, baseProps), children);
};
AppShellProvider.propTypes = {
  children: PropTypes.node.isRequired,
  site: PropTypes.string,
  brand: PropTypes.string,
  locale: PropTypes.string,
  currencyLocale: PropTypes.object,
  dateLocale: PropTypes.object,
  baseProps: PropTypes.shape({
    featureVariationsInput: PropTypes.shape({
      aliases: PropTypes.array
    })
  })
};
const FrontendApiProvider = ({
  logger,
  graphQLClient,
  schema,
  queryClient,
  children,
  tokenFallback
}) => /*#__PURE__*/React.createElement(FrontendApiConfigProvider, {
  graphQLEndpoint: "/frontend-api/service/graphql",
  schema: schema
}, /*#__PURE__*/React.createElement(HeadersProvider, {
  tokenFallback: tokenFallback,
  logger: logger
}, /*#__PURE__*/React.createElement(FrontendApiClientBaseProvider, {
  queryClient: queryClient
}, /*#__PURE__*/React.createElement(FrontendApiClientProvider, {
  graphQLClient: graphQLClient
}, children))));
FrontendApiProvider.propTypes = {
  logger: PropTypes.object,
  tokenFallback: PropTypes.string,
  storageClient: PropTypes.object,
  queryClient: PropTypes.object,
  graphQLClient: PropTypes.object,
  schema: PropTypes.string,
  children: PropTypes.node
};
export const AppProvider = ({
  currencyLocale,
  currencyFormat,
  dateLocale,
  site,
  brand,
  locale,
  baseProps,
  routingProps,
  appErrorProps,
  frontendAPIClientProps,
  children,
  namespace,
  disableTracking
}) => /*#__PURE__*/React.createElement(AppErrorProvider, appErrorProps, /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
  namespace: namespace
}, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
  name: "app_provider"
}, /*#__PURE__*/React.createElement(FrontendApiProvider, frontendAPIClientProps, /*#__PURE__*/React.createElement(AppShellProvider, {
  site: site,
  brand: brand,
  locale: locale,
  currencyLocale: currencyLocale,
  currencyFormat: currencyFormat,
  dateLocale: dateLocale,
  baseProps: baseProps,
  disableTracking: disableTracking
}, /*#__PURE__*/React.createElement(RoutingProvider, routingProps, children))))));
AppProvider.propTypes = _objectSpread(_objectSpread({}, AppShellProvider.propTypes), {}, {
  appErrorProps: PropTypes.object,
  frontendAPIClientProps: PropTypes.object,
  namespace: PropTypes.string
});